import { getCurrentInstance } from "vue";
import { useStore } from "vuex";

export function useDialog() {
  const store = useStore();
  const { proxy } = getCurrentInstance();

  const showAlert = (options = {}) => {
    const defaultOptions = {
      type: "alert",
      text: "",
      desc: "",
      note: "",
      showIcon: true,
      isCanCancel: false,
      closeText: null,
      cancelText: null,
      contentClass: "",
      presentation: null
    };

    return store.dispatch("dialog/showDialog", {
      ...defaultOptions,
      ...options
    });
  };

  const showConfirm = (options = {}) => {
    const defaultOptions = {
      type: "confirm",
      header: "",
      text: "",
      subText: "",
      button: {
        true: { msg: "ยืนยัน", class: ["btn-success"] },
        false: { msg: "ยกเลิก", class: ["btn-danger"] }
      },
      contentClass: "",
      presentation: null
    };

    return store.dispatch("dialog/showDialog", {
      ...defaultOptions,
      ...options
    });
  };

  const showError = (options = {}) => {
    const defaultErrorMessage = proxy.$t("error_message");
    const defaultOptions = {
      type: "error",
      header: defaultErrorMessage,
      text: "",
      subText: "",
      showIcon: true,
      closeText: null,
      contentClass: "",
      presentation: null
    };

    return store.dispatch("dialog/showDialog", {
      ...defaultOptions,
      ...options
    });
  };

  const showCustom = (component, props = {}, options = {}) => {
    const defaultOptions = {
      type: "custom",
      contentClass: "",
      width: null,
      maxWidth: null,
      presentation: null
    };

    return store.dispatch("dialog/showDialog", {
      ...defaultOptions,
      ...options,
      component,
      props
    });
  };

  const closeDialog = result => {
    store.dispatch("dialog/closeDialog", result);
  };

  const clearDialogs = () => {
    store.commit("dialog/clear");
  };

  return {
    showAlert,
    showConfirm,
    showError,
    showCustom,
    closeDialog,
    clearDialogs
  };
}

export default useDialog;
